<template>
  <div class="alert-confirm-container">
    <v-dialog
      eager
      @input="change"
      value="true"
      :max-width="width"
      :persistent="persistent"
      class="app-confirm-dialog"
      data-app
      app-data="true"
      light
      hide-overlay
      @keydown.esc="choose(false)"
    >
      <v-card tile class="app-confirm-dialog-body">
        <v-toolbar v-if="Boolean(title)" dark :color="'white'" dense flat>
          <v-toolbar-title class="dark--text" v-text="title" />
          <v-spacer />
          <FIcon name="close" size="1rem" color="241800" @click.native="choose(false)" />
        </v-toolbar>
        <v-card-text class="body-1 text-body-1 py-3" v-html="message" />
        <div class="card-actions" :class="{ threeActions: this.isContainsThreeActions }">
          <v-btn
            v-if="Boolean(buttonFalseText)"
            :color="buttonFalseColor"
            :outlined="buttonFalseOutlined"
            :text="buttonFalseFlat"
            @click="choose(false)"
          >
            {{ buttonFalseText }}
          </v-btn>

          <div class="positive-actions">
            <v-btn
              v-if="isContainsThreeActions"
              :color="buttonActionColor"
              :outlined="buttonFalseOutlined"
              :text="buttonTrueFlat"
              @click="handleOnOtherFunctionCall()"
              class="secondary-action-btn"
            >
              {{seconderyActionText}}
            </v-btn>
            <v-btn
              v-if="Boolean(buttonTrueText)"
              :color="buttonTrueColor"
              :outlined="buttonTrueOutlined"
              :text="buttonTrueFlat"
              @click="choose(true)"
              class="true-button"
            >
              {{ buttonTrueText }}
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <div class="dialog-overlay" />
  </div>
</template>

<script>
export default {
  props: {
    buttonTrueText: {
      type: String,
      default: "",
    },

    buttonFalseText: {
      type: String,
      default: "",
    },

    buttonTrueColor: {
      type: String,
      default: "primary",
    },

    buttonFalseColor: {
      type: String,
      default: "grey",
    },

    buttonFalseFlat: {
      type: Boolean,
      default: true,
    },

    buttonTrueFlat: {
      type: Boolean,
      default: true,
    },

    buttonFalseOutlined: {
      type: Boolean,
      default: true,
    },

    buttonTrueOutlined: {
      type: Boolean,
      default: false,
    },

    color: {
      type: String,
      default: "warning",
    },

    message: {
      type: String,
      required: true,
    },

    persistent: Boolean,

    title: {
      type: String,
    },

    width: {
      type: Number,
      default: 450,
    },

    seconderyActionFunction: {
      type: Function,
      default: null,
    },

    buttonActionColor: {
      type: String,
      default: "primary",
    },
    isContainsThreeActions: {
      type: Boolean,
      default: false,
    },
    seconderyActionText :{
      type:String,
      default:""
    }
  },

  data() {
    return {
      value: false,
    };
  },

  mounted() {
    document.addEventListener("keyup", this.onEnterPressed);
  },

  destroyed() {
    document.removeEventListener("keyup", this.onEnterPressed);
  },

  methods: {
    /**
     * Handle on Enter pressed
     * @param {Object} e
     * @return {void}
     */
    onEnterPressed(e) {
      if (e.keyCode === 13) {
        e.stopPropagation();
        this.choose(true);
      }
    },

    /**
     * Handle on choose
     * @param {boolean} value
     * @return {void}
     */
    choose(value) {
      this.$emit("result", value);
      this.value = value;
      this.$destroy();
    },

    /**
     * Handle on change choose
     * @param {any} response
     * @return {void}
     */
    change(response) {
      this.$destroy();
    },

    handleOnOtherFunctionCall() {
      this.seconderyActionFunction(true);
      this.$destroy();
    },
  },
};
</script>

<style scoped lang="scss" src="./styles.scss" />
